'use strict';

angular.module('ntmApp')
  .controller('saveReportFiltersSetController', ['$scope', '$uibModalInstance', 'data', 'Constants', 'FlashService','ReportService',
    function ($scope, $uibModalInstance, data, Constants, FlashService, ReportService) {

      var init = function () {
        $scope.selectedReportFilterSet = data;
        $scope.reportFiltersSetName = data.storedReportFilterSetName;
      };

      $scope.saveReportFilterSet = function (action) {

        var request = $scope.selectedReportFilterSet;

        if(!$scope.reportFiltersSetName || $scope.reportFiltersSetName.length === 0){
           FlashService.Error("Filters Set Name is empty. Please enter а valid value.", false);
           return;
        }

        if (action == 'asNew') {
          request.action = Constants.DBActions.Insert;
          request.storedReportFilterSetName = $scope.reportFiltersSetName;
        } else {
          if ($scope.selectedReportFilterSet.storedReportFilterSetId)
            request.action = Constants.DBActions.Update;
          else
            request.action = Constants.DBActions.Insert;
          request.storedReportFilterSetName = $scope.reportFiltersSetName;
        }

        var loading = FlashService.Loading();
        ReportService.ReportFilterSetAction(request).then(function (response) {
          if (response.success) {
            FlashService.Success("<b>\"{0}\" </b> report filters set has been saved.".format(request.storedReportFilterSetName));
            $scope.selectedReportFilterSet.saveCallBack(response.data);
            $scope.close();
          }
          loading.dismiss();
        });
      };

      $scope.close = function () {
        event.preventDefault();
        $uibModalInstance.close();
      };

      $scope.$on('modal.closing', function (event, reason) {
        switch (reason) {
          // clicked outside
          case "backdrop click":
            event.preventDefault();
            $scope.close(event);
            break;
          // escape key
          case "escape key press":
            event.preventDefault();
            $scope.close(event);
            break;
        }
      });

      $scope.cancel = function (closeType) {
        $uibModalInstance.close(closeType || false);
      };

      init();
    }]);
